module.exports = __webpack_public_path__ + "media/step10_animation.ec40bafa.mp4";